<template>
  <div>
    <div id="header" class="header">
      <div class="header-nav"><!-- 공백 --></div>
      <div class="header-gnb">
        <h1 class="logo">
          <a href="/index.html">
            <img src="../../assets/images/common/ci-wavve.png" alt="wavve" />
          </a>
        </h1>
        <ul class="gnb-left">
          <li><a href="/customer/company.html" id="g-menu">회사소개</a></li>
          <li><a href="/customer/business.html">사업제휴</a></li>
          <li><a href="/customer/recruit.html" class="on">인재채용</a></li>
          <li><a href="/customer/financial_statements.html">투자정보</a></li>
        </ul>
      </div>
    </div>

    <!-- 콘텐츠 영역 -->
    <div id="container" class="container">
      <!-- service -->
      <div class="service">
        <!-- top -->
        <div class="top-contents company-top-contents" id="g-contents">
          <div class="wrap">
            <h1 class="cp-h1">재미의 파도를 타다!<br />콘텐츠웨이브</h1>
          </div>
        </div>
        <!--// top -->

        <!-- sticky nav -->
        <div id="sticky-menu" class="sticky-navigation">
          <ul>
            <li>
              <a href="#i-sec01" v-smooth-scroll="{offset:-64}" class="scroll on">인재상</a>
            </li>
            <li>
              <a href="#i-sec02" v-smooth-scroll="{offset:-64}" class="scroll">채용공고</a>
            </li>
          </ul>
        </div>
        <!--// sticky nav -->

        <div class="contents-wrap">
          <!-- ability 01 -->
          <div id="i-sec01">
            <div class="ability-sec01 tAc">
              <div class="if-wrap">
                <h2 class="title">콘텐츠웨이브 인재상</h2>
                <p class="sub-title">올바른 기본기를 바탕으로 미래를 꿈꾸는 사람</p>
                <div class="ab-sec01-list">
                  <span class="list-cir01">조화</span>
                  <p class="list-txt">이용자 만족, 조직의 요구, 개인 가치관의 조화를 이루는 사람</p>
                </div>
                <div class="ab-sec01-list">
                  <span class="list-cir02">비전</span>
                  <p class="list-txt">맡은 업무에서 비전을 제시하는 사람</p>
                </div>
                <div class="ab-sec01-list">
                  <span class="list-cir01">실행력</span>
                  <p class="list-txt">목표를 꼼꼼히 실행하는 사람</p>
                </div>
                <div class="ab-sec01-list">
                  <span class="list-cir02">소통</span>
                  <p class="list-txt">저마다의 입장을 이해하고 소통을 통해 문제를 해결하는 사람</p>
                </div>
                <div class="ab-sec01-list">
                  <span class="list-cir01">전문성</span>
                  <p class="list-txt">전문지식과 트렌드를 끊임없이 학습하여 기회를 찾는 사람</p>
                </div><!--// list -->
              </div>
            </div>
          </div>
          <!--// ability 01 -->

          <!-- ability 02 -->
          <div id="i-sec02">
            <div class="ability-sec02">
              <div class="if-wrap">
                <h2 class="title tAc">채용공고</h2>
                <div class="ab-sec02-nav">
                  <a @click.prevent="changeCategory('all')" href="#" :class="category === 'all' ? 'on' : ''">전체</a>
                  <a @click.prevent="changeCategory('101')" href="#" :class="category === '101' ? 'on' : ''">인턴</a>
                  <a @click.prevent="changeCategory('102')" href="#" :class="category === '102' ? 'on' : ''">신입</a>
                  <a @click.prevent="changeCategory('103')" href="#" :class="category === '103' ? 'on' : ''">경력</a>
                </div>
                <!--// nav -->

                <!-- 현재 진행중인 채용 공고가 없습니다. -->
                <div v-if="dataList && dataList.length < 1">
                  <empty emptyType="recruit" />
                </div>

                <div v-else>
                  <!-- 채용 목록 -->
                  <template v-if="!dataDetail">
                    <table class="ab-sec02-table">
                      <colgroup>
                        <col width="*" />
                        <col width="140px" />
                      </colgroup>
                      <tr>
                        <th colspan="row">제목</th>
                        <th colspan="row">등록일</th>
                      </tr>
                      <!-- 채용 목록 리스트 -->
                      <tr v-for="(data, index) in dataList" :key="index" :class="data.istop ==='y' ? 'noti-top' : ''">
                        <td class="tAl">
                          <a @click.prevent="showDetail(data)" href="#"
                             v-html="data.boardtitle + (data.isNew === 'y' ? '<i>NEW</i>' : '')">
                          </a>
                        </td>
                        <td>{{ data.regdate }}</td>
                      </tr>
                    </table>

                    <!-- 페이징 -->
                    <paging-component :current-page="page"
                                      :page-count="pageCount"
                                      :limit="limit"
                                      :paging-count="10"
                                      :isLoading="false"/>
                  </template>

                  <!-- 채용 상세 -->
                  <template v-else-if="dataDetail">
                    <table class="ab-sec02-table hover-none">
                      <colgroup>
                        <col width="*">
                        <col width="140px">
                      </colgroup>
                      <tbody><tr>
                        <th>제목</th>
                        <th>등록일</th>
                      </tr>
                      <tr>
                        <td class="tAl">
                          <p class="title" v-html="dataDetail.boardtitle + (this.isNew === 'y' ? '<i>NEW</i>' : '')"></p>
                        </td>
                        <td>{{ dataDetail.regdate }}</td>
                      </tr>
                      <tr>
                        <td colspan="2">
                          <div class="table-wrapper" v-html="dataDetail.content"></div>
                          <ul class="table-list">
                            <li>
                              <a @click.prevent="showDetail(dataDetail.prev)" href="#">
                                <span class="txt-type01">이전글</span>
                                <span v-if="dataDetail.prev.boardtitle" class="txt-type02">{{ dataDetail.prev.boardtitle }}</span>
                                <span v-else class="txt-type02">이전글이 없습니다.</span>
                                <span class="txt-type03">{{ dataDetail.prev.regdate }}</span>
                              </a>
                            </li>
                            <li>
                              <a @click.prevent="showDetail(dataDetail.next)" href="#">
                                <span class="txt-type01">다음글</span>
                                <span v-if="dataDetail.next.boardtitle" class="txt-type02">{{ dataDetail.next.boardtitle }}</span>
                                <span v-else class="txt-type02">다음글이 없습니다.</span>
                                <span class="txt-type03">{{ dataDetail.next.regdate }}</span>
                              </a>
                            </li>
                          </ul>
                        </td>
                      </tr>
                      </tbody>
                    </table>

                    <a @click.prevent="showList()" href="#" class="prev-list">
                      <img src="../../assets/images/service/btn-list.png" alt="list">
                      목록
                    </a>
                  </template>
                </div>
              </div>
            </div>
          </div>
          <!--// ability 02 -->
        </div>
      </div>
      <!--// service -->
    </div>
  </div>
</template>

<script>
import PagingComponent from '@/components/common/PagingComponent'
import Empty from '@/components/common/Empty'
import { getNoticesCompanyInfoBoard, getNoticesCompanyInfoBoardDetail } from '@/common/utils/request'
import queryString from '@/common/utils/querystring'
import { customerSubMenuScrollEvent } from '@/common/utils/common'
import _ from 'lodash'
export default {
  components: {
    PagingComponent,
    Empty
  },
  data () {
    return {
      page: +queryString.getQueryParamValue(this.$route, 'page', '1'),
      category: queryString.getQueryParamValue(this.$route, 'category', 'all'),
      isNew: undefined,
      sticky: false,
      dataList: undefined, // 채용 목록 데이터
      dataDetail: undefined, // 채용 상세 데이터
      limit: 10,
      pageCount: 0,
      orderby: 'new',
      contentElList: [],
      subMenuElList: [],
      subMenuContentElList: [],
      stickyMenuEl: {}
    }
  },
  methods: {
    callApi () {
      let offset = this.limit * (this.page - 1)
      this.dataDetail = undefined
      getNoticesCompanyInfoBoard({ type: 'all', subtype: this.category, top: 'all', offset, limit: this.limit, orderby: this.orderby }).then((response) => {
        this.dataList = response.data.list
        this.pageCount = +response.data.pagecount
        this.isNoticeList = true
      })
    },
    changeCategory (category) {
      this.category = category
      this.page = 1
      this.callApi()
    },
    showDetail (data) {
      this.isNew = data.isNew
      if (!data || !data.boardid) {
        return
      }

      getNoticesCompanyInfoBoardDetail({ type: 'none', subtype: this.category, boardid: data.boardid })
        .then((response) => {
          this.dataDetail = response.data
        })
    },
    goDetailPage (noticeId) {
      if (!noticeId) return
      let strUrl = '/customer/notice_view.html?filterType=' + this.filterType + '&noticeId=' + noticeId + '&pageNum=' + this.currentPage
      if (this.searchWord && this.searchWord !== '') { strUrl += '&searchWord=' + encodeURIComponent(this.searchWord) }
      window.location.href = strUrl
    },
    showList () {
      this.callApi()
    },
    scrollThrottleEvent: _.throttle(function () {
      customerSubMenuScrollEvent(this.stickyMenuEl, this.contentElList, this.subMenuElList)
    }, 150)
  },
  mounted () {
    this.callApi()
    this.contentElList = document.querySelectorAll('div[id^=i-sec]')
    this.stickyMenuEl = document.getElementById('sticky-menu')
    this.subMenuElList = document.querySelectorAll('#sticky-menu li a')
    window.addEventListener('scroll', this.scrollThrottleEvent)
    // 페이지 변경 이벤트 등록
    this.$events.$on('changePageNum', (page) => {
      this.page = page
      this.callApi()
    })
  },
  beforeDestroy () {
    this.$events.$off('changePageNum')
    window.removeEventListener('scroll', this.scrollThrottleEvent)
  }
}
</script>
<style lang="css" src="@/assets/css/service.css"></style>
